(function() {
  function generateAntibot() {
    var num1 = Math.floor(Math.random() * 50) + 10;
    var num2 = Math.floor(Math.random() * num1);
    return { num1: num1, num2: num2, answer: num1 - num2 };
  }

  function updateAntibotLabel(label, antibot) {
    if (!label || !antibot) return;
    label.textContent = "Сколько будет " + antibot.num1 + " - " + antibot.num2 + "?";
  }

  function checkAntibot(value, answer) {
    return String(parseInt(value, 10)) === String(answer);
  }

  function setFormSubmitting(form, isSubmitting) {
    if (!form) return;
    var submitButton = form.querySelector(".form_step2_submit");
    var loader = form.querySelector(".form_step2_loader");
    if (submitButton) submitButton.disabled = isSubmitting;
    if (loader) loader.style.display = isSubmitting ? "block" : "none";
    form.dataset.submitting = isSubmitting ? "true" : "false";
  }

  function syncPhoneCode(form) {
    if (!form) return;
    form.querySelectorAll('input[type="tel"][id^="phone_step2_"]').forEach(function(input) {
      var wrapper = input.closest(".phone_wrapper");
      var codeNode = wrapper ? wrapper.querySelector(".phone-code") : null;
      var hiddenNode = wrapper ? wrapper.querySelector('input[type="hidden"][name="request[parent_phone_code]"]') : null;
      if (codeNode && hiddenNode) hiddenNode.value = codeNode.textContent.trim();
    });
  }

  function submitSecondaryRequestForm(form) {
    if (!form || form.dataset.submitting === "true") return;

    syncPhoneCode(form);
    setFormSubmitting(form, true);

    var csrfToken =
      (document.querySelector('meta[name="csrf-token"]') || {}).content ||
      (form.querySelector('input[name="authenticity_token"]') || {}).value;

    fetch(form.action, {
      method: (form.method || "POST").toUpperCase(),
      body: new FormData(form),
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        "X-CSRF-Token": csrfToken || "",
        "Accept": "text/javascript"
      },
      credentials: "same-origin"
    })
      .then(function(response) {
        return response.text().then(function(text) {
          if (!response.ok) throw new Error("Request failed: " + response.status);
          return text;
        });
      })
      .then(function(jsResponse) {
        var script = document.createElement("script");
        script.textContent = jsResponse;
        document.head.appendChild(script);
        document.head.removeChild(script);
      })
      .catch(function(error) {
        console.error(error);
        alert("Ошибка отправки формы. Попробуйте ещё раз.");
        setFormSubmitting(form, false);
      });
  }

  function currentLanguage(formStep1) {
    var form = formStep1 ? formStep1.closest("form") : null;
    var savedLang = (window.localStorage && window.localStorage.getItem("siteLanguage")) || "";
    var formLang = form ? String(form.dataset.lang || "").trim() : "";
    var htmlLang = String((document.documentElement && document.documentElement.lang) || "").trim();
    var pathLang = window.location.pathname.indexOf("/en-") >= 0 ? "en" : "ru";
    var lang = savedLang || formLang || htmlLang || pathLang;
    return String(lang).toLowerCase().indexOf("en") === 0 ? "en" : "ru";
  }

  function antibotTemplateFor(formStep1) {
    return currentLanguage(formStep1) === "en"
      ? (formStep1 && formStep1.dataset.antibotTemplateEn) || "How much is {num1} - {num2}?"
      : (formStep1 && formStep1.dataset.antibotTemplateRu) || "Сколько будет {num1} - {num2}?";
  }

  function updateCampusImage(formKey) {
    var campusSelect = document.getElementById("campus_" + formKey);
    var imageElement = document.getElementById("campusImage_" + formKey);
    var captionElement = document.getElementById("campusCaption_" + formKey);
    var desktopImageElement = document.getElementById("campusImage_" + formKey + "_desktop");
    var desktopCaptionElement = document.getElementById("campusCaption_" + formKey + "_desktop");

    if (!campusSelect) return;

    var apply = function() {
      var option = campusSelect.selectedOptions && campusSelect.selectedOptions[0];
      var imageSrc = option && option.dataset.image ? option.dataset.image : "";
      var captionText = option && option.dataset.caption ? option.dataset.caption : (option ? option.textContent : "");

      if (imageElement && imageSrc) imageElement.src = imageSrc;
      if (desktopImageElement && imageSrc) desktopImageElement.src = imageSrc;
      if (captionElement) captionElement.textContent = captionText;
      if (desktopCaptionElement) desktopCaptionElement.textContent = captionText;
    };

    campusSelect.addEventListener("change", apply);
    apply();
  }

  function updateStep2PhoneState(formKey) {
    var step1Selector = document.getElementById("phoneFlagSelector_" + formKey);
    var step1Code = document.getElementById("phoneCode_" + formKey);
    var step1Flag = document.getElementById("phoneFlagImg_" + formKey);
    var step2Selector = document.getElementById("phoneFlagSelector_step2_" + formKey);
    var step2Code = document.getElementById("phoneCode_step2_" + formKey);
    var step2Flag = document.getElementById("phoneFlagImg_step2_" + formKey);
    var step2Input = document.getElementById("phone_step2_" + formKey);
    var phoneStep1 = document.getElementById("phone_" + formKey);

    if (step2Code && step1Code) step2Code.textContent = step1Code.textContent.trim();
    if (step2Flag && step1Flag) {
      var clonedFlag = step1Flag.cloneNode(true);
      clonedFlag.id = step2Flag.id;
      step2Flag.replaceWith(clonedFlag);
    }
    if (step2Selector && step1Selector && step1Selector.dataset.selectedIso) {
      step2Selector.dataset.selectedIso = step1Selector.dataset.selectedIso;
    }

    if (step2Input && phoneStep1) {
      step2Input.value = phoneStep1.value.trim();
    }
  }

  function getStep2Country(formKey) {
    var codeNode = document.getElementById("phoneCode_step2_" + formKey);
    if (!codeNode || typeof window.getCountryByCode !== "function") return null;
    return window.getCountryByCode(codeNode.textContent.trim());
  }

  function formatStep2PhoneValue(input, formKey) {
    if (!input || typeof window.formatPhoneNumber !== "function") return;
    var country = getStep2Country(formKey);
    if (!country) return;

    var formatted = window.formatPhoneNumber(input.value || "", country.code);
    if (formatted !== input.value) {
      input.value = formatted;
    }

    input.dataset.countryCode = country.code;
    if (country.placeholder) {
      input.placeholder = country.placeholder;
      input.dataset.correctPlaceholder = country.placeholder;
    }
  }

  function bindStep2PhoneFormatter(input, formKey) {
    if (!input || input.dataset.step2FormatterBound === "true") return;

    var applyFormatting = function() {
      formatStep2PhoneValue(input, formKey);
    };

    input.addEventListener("input", applyFormatting);
    input.addEventListener("blur", applyFormatting);
    input.dataset.step2FormatterBound = "true";
    applyFormatting();
  }

  function isStep2PhoneValid(formKey) {
    var input = document.getElementById("phone_step2_" + formKey);
    var codeNode = document.getElementById("phoneCode_step2_" + formKey);
    if (!input || !codeNode || typeof window.validatePhoneNumber !== "function") return false;
    return window.validatePhoneNumber(input.value || "", codeNode.textContent.trim()).valid;
  }

  function initForm(formStep1) {
    var formKey = formStep1.dataset.secondaryLeadForm;
    var form = formStep1.closest("form");
    var phone = document.getElementById("phone_" + formKey);
    var comment = document.getElementById("comment_" + formKey);
    var nextButton = document.getElementById("submitBtn_" + formKey);
    var step2 = document.getElementById("formStep2_" + formKey);
    var phoneStep2 = document.getElementById("phone_step2_" + formKey);
    var parentName = document.getElementById("parent_name_" + formKey);
    var email = document.getElementById("email_" + formKey);
    var birthDate = document.getElementById("birth_date_" + formKey);
    var campusSelect = document.getElementById("campus_" + formKey);
    var submitStep2 = document.getElementById("submitStep2_" + formKey);
    var phoneCodeField = document.getElementById("parent_phone_code_" + formKey);
    var antibotLabel = document.getElementById("antibotLabel_" + formKey);
    var step1Title = formStep1.querySelector(".form_txt");
    var step1InputGroup = formStep1.querySelector(".input_group");
    var step1AltText = formStep1.querySelector(".alt_text");

    if (!phone || !comment || !nextButton || !step2 || !submitStep2) return;

    if (form && step2.parentElement !== form) {
      form.insertBefore(step2, formStep1.nextSibling);
    }

    var antibot = generateAntibot();
    updateAntibotLabel(antibotLabel, antibot);

    function updateStep1State() {
      var phoneValid = true;
      if (typeof window.validatePhoneNumber === "function") {
        var phoneCodeNode = document.getElementById("phoneCode_" + formKey);
        var phoneCode = phoneCodeNode ? phoneCodeNode.textContent.trim() : "+7";
        phoneValid = window.validatePhoneNumber(phone.value || "", phoneCode).valid;
      }
      nextButton.disabled = !(phoneValid && checkAntibot(comment.value.trim(), antibot.answer));
    }

    function markField(field, valid) {
      if (!field) return;
      field.classList.toggle("error", !valid);
    }

    function showStep2() {
      formStep1.style.display = "none";
      step2.style.display = "flex";
    }

    function validateStep2() {
      var isValid = true;
      var missingFields = [];

      var phoneValid = isStep2PhoneValid(formKey);
      var phoneInput = document.getElementById("phone_step2_" + formKey);
      markField(phoneInput, phoneValid);
      if (!phoneValid) {
        isValid = false;
        missingFields.push("Телефон");
      }

      var parentNameValue = parentName ? String(parentName.value || "").trim() : "";
      markField(parentName, !!parentNameValue);
      if (!parentNameValue) {
        isValid = false;
        missingFields.push("Имя и фамилия родителя");
      }

      var emailValue = email ? String(email.value || "").trim() : "";
      var emailValid = !!emailValue && typeof window.validateEmail === "function" && window.validateEmail(emailValue);
      markField(email, emailValid);
      if (!emailValid) {
        isValid = false;
        missingFields.push("Email");
      }

      var birthDateValue = birthDate ? String(birthDate.value || "").trim() : "";
      if (birthDateValue && typeof window.validateBirthDate === "function" && !window.validateBirthDate(birthDateValue)) {
        markField(birthDate, false);
        isValid = false;
        missingFields.push("Дата рождения");
      } else if (birthDate) {
        markField(birthDate, true);
      }

      var campusValue = campusSelect ? String(campusSelect.value || "").trim() : "";
      markField(campusSelect, !!campusValue);
      if (!campusValue) {
        isValid = false;
        missingFields.push("Кампус");
      }

      return { isValid: isValid, missingFields: missingFields };
    }

    phone.addEventListener("input", function() {
      if (phone.value) {
        phone.classList.remove("error");
      }
      updateStep1State();
    });
    comment.addEventListener("input", updateStep1State);
    comment.addEventListener("blur", updateStep1State);
    updateStep1State();

    if (campusSelect) {
      campusSelect.addEventListener("change", function() {
        campusSelect.classList.remove("error");
      });
      updateCampusImage(formKey);
    }

    if (email) {
      email.addEventListener("input", function() {
        if (!email.value || typeof window.validateEmail !== "function" || window.validateEmail(email.value)) {
          email.classList.remove("error");
        }
      });
    }

    if (birthDate) {
      birthDate.addEventListener("input", function() {
        birthDate.classList.remove("error");
      });
    }

    if (parentName) {
      parentName.addEventListener("input", function() {
        parentName.classList.remove("error");
      });
    }

    if (phoneStep2) {
      phoneStep2.addEventListener("input", function() {
        if (phoneStep2.value) {
          phoneStep2.classList.remove("error");
        }
      });
      bindStep2PhoneFormatter(phoneStep2, formKey);
    }

    nextButton.addEventListener("click", function() {
      if (nextButton.disabled) return;
      showStep2();
      updateStep2PhoneState(formKey);
      formatStep2PhoneValue(phoneStep2, formKey);
    });

    submitStep2.addEventListener("click", function(event) {
      event.preventDefault();

      var result = validateStep2();
      if (!result.isValid) {
        alert("Пожалуйста, заполните обязательные поля: " + result.missingFields.join(", "));
        return;
      }

      if (phoneCodeField) {
        var codeNode = document.getElementById("phoneCode_step2_" + formKey);
        phoneCodeField.value = codeNode ? codeNode.textContent.trim() : "";
      }

      setFormSubmitting(form, true);
      submitSecondaryRequestForm(form);
    });
  }

  function init() {
    document.querySelectorAll("[data-secondary-lead-form]").forEach(initForm);
  }

  if (typeof window.generateAntibot !== "function") window.generateAntibot = generateAntibot;
  if (typeof window.updateAntibotLabel !== "function") window.updateAntibotLabel = updateAntibotLabel;
  if (typeof window.checkAntibot !== "function") window.checkAntibot = checkAntibot;
  if (typeof window.setFormSubmitting !== "function") window.setFormSubmitting = setFormSubmitting;
  if (typeof window.submitSecondaryRequestForm !== "function") window.submitSecondaryRequestForm = submitSecondaryRequestForm;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
